import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { isRequired } from 'components/Questionnaires/validators';

export const QuestionNumberField = ({ intl, blockId, question, className, onChange, min, max }) => {
  const regex = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/;

  const defaultValue = () => {
    if (question?.answer && regex.test(question?.answer)) {
      return question.answer;
    }
    if (question?.default && regex.test(question?.default)) {
      return question.default;
    }
    return '';
  };

  const [inputValue, setInputValue] = useState(defaultValue);

  function onKeyHandler(event) {
    if (event === null || event.keyCode === 69) { // e or E
      event.preventDefault();
    }
  }

  const onInputChange = (event) => {
    const { value } = event.target;
    if (value !== '' && !regex.test(value)) {
      return false;
    }
    setInputValue(value);
    onChange(question, value);
    return true;
  };

  useEffect(() => {
    if (inputValue) {
      onChange(question, inputValue);
    }
  }, []);

  return (<input
    key={ `${ blockId }-${ question.id }` }
    id={ `${ blockId }-${ question.id }` }
    name={ question.id }
    value={ inputValue }
    onKeyDown={ e => onKeyHandler(e) }
    onChange={ e => onInputChange(e) }
    placeholder={ (question.placeholder ?? question.label) ? intl.formatMessage({ id: question.placeholder ?? question.label }) : '' }
    autoComplete="no"
    className={ `${ className }${ question.isValid === false ? ' error' : '' }` }
    disabled={ question.disabled }
    type="number"
    min={ min }
    max={ max }
    required={ isRequired(question) }
    aria-label={ (question.placeholder ?? question.label) ? intl.formatMessage({ id: question.placeholder ?? question.label }) : '' }
    aria-required={ isRequired(question) }
    aria-describedby={ question.isValid === false ? (`${ blockId }-${ question.id }-error`) : undefined }
  />);
};

QuestionNumberField.displayName = 'QuestionNumberField';

QuestionNumberField.propTypes = {
  intl: PropTypes.shape().isRequired,
  blockId: PropTypes.string.isRequired,
  question: PropTypes.shape().isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number
};

QuestionNumberField.defaultProps = {
  className: '',
  min: null,
  max: null
};

export default QuestionNumberField;
